module.exports = __webpack_public_path__ + "img/digital_clock_closeup.9b1556b8.png";